'use client';

import type { UIComponentProps } from '@wolfejs/ui/types/UI';

export type LoadingProps = UIComponentProps & {};

export const Loading = ({ ...otherProps }: LoadingProps) => {
  return <div {...otherProps}>Loading...</div>;
};
